import CircleCheck from '@/app/_components/Icon/CircleCheck'
import { cn } from '@/app/_primitives/utils/cn'
import React, { useTransition } from 'react'

export default function CheckboxBadge({
  children,
  checked,
  onChecked,
  className,
}: {
  children: React.ReactNode
  checked: boolean
  onChecked: (_: boolean) => unknown
  className?: string
}) {
  const [isPending, startTransition] = useTransition()

  return (
    <button
      onClick={() => {
        startTransition(() => {
          onChecked(!checked)
        })
      }}
      type="button"
      className={cn(
        'flex cursor-pointer items-center justify-center gap-4 rounded-100 bg-neutral-100 px-12 py-4 outline-none focus-visible:outline-none',
        {
          'bg-fblue-light-hover': checked,
        },
        {
          'cursor-wait': isPending,
        },
        className,
      )}>
      <p className="c-b4 flex-1 text-[#171717]">{children}</p>
      {checked && <CircleCheck className="size-16 shrink-0 fill-french-bleu" />}
      {!checked && <CircleCheck className="size-16 fill-neutral-300" />}
    </button>
  )
}
